import * as Logger from '../libs/wa-logger'
import * as Guards from "../libs/guards"
import * as OnBigSmall from '../components/on-screen-big-small'

let mm: MainMenuClass

export function initialize(selector: string) {
	mm = new MainMenuClass(selector);

	// const columns = (document.querySelectorAll(selector) as unknown) as HTMLDivElement[]
	// let currentHeight
	// let tallestcolumn = 0
	// let isBig = false

	// const setColumns = function setColumns(pcolumns: HTMLDivElement[]) {
	// 	pcolumns.forEach((el, ix) => { // eslint-diable no-unused-vars
	// 		const element = Guards.isHTMLDiv(el)
	// 		currentHeight = Math.max(element.scrollHeight, element.clientHeight)
	// 		Logger.log([`colequal currentHeight `, currentHeight])
	// 		if (currentHeight > tallestcolumn) {
	// 			tallestcolumn = currentHeight
	// 		}
	// 	});
	// 	columns.forEach((el: HTMLDivElement, ix) => {
	// 		// $(el).height(tallestcolumn)
	// 		el.style.height = `${tallestcolumn}px`
	// 	})
	// };

	// const resetColumns = function resetColumns(pcolumns: HTMLDivElement[]) {
	// 	pcolumns.forEach((el: HTMLDivElement) => {
	// 		el.style.height = ''
	// 	});
	// };

	// const onGoingLarge = () => {
	// 	Logger.log('equalHeight::GOING MEDIUM screen entered');
	// 	if (!isBig) {
	// 		setColumns(columns)
	// 		isBig = true;
	// 	}
	// };

	// const onGoingSmall = () => {
	// 	Logger.log('equalHeight::GOING SMALL screen entered');
	// 	if (isBig) {
	// 		resetColumns(columns)
	// 		isBig = false;
	// 	}
	// };

	// OnBigSmall.register(onGoingLarge, onGoingSmall);
}
class MainMenuClass
{
	public selector: string
	public columns: HTMLDivElement[]
	public tallest_column: number
	public current_height: number
	public is_big: boolean
	constructor(selector: string) {
		this.selector = selector
		this.columns = (document.querySelectorAll(this.selector) as unknown) as HTMLDivElement[]
	}
	public setColumns() {
		this.tallest_column = 0
		this.columns = (document.querySelectorAll(this.selector) as unknown) as HTMLDivElement[]
		this.columns.forEach((el, ix) => { // eslint-diable no-unused-vars
			const element = Guards.isHTMLDiv(el)
			this.current_height = Math.max(element.scrollHeight, element.clientHeight)
			Logger.log([`colequal currentHeight `, this.current_height])
			if (this.current_height > this.tallest_column) {
				this.tallest_column = this.current_height
			}
		});
		this.columns.forEach((el: HTMLDivElement, ix) => {
			// $(el).height(tallestcolumn)
			el.style.height = `${this.tallest_column}px`
		})
	};

	public resetColumns() {
		this.columns = (document.querySelectorAll(this.selector) as unknown) as HTMLDivElement[]
		this.columns.forEach((el: HTMLDivElement) => {
			el.style.height = ''
		});
	};

}
export function handle_media_query(is_small: boolean)
{
	if(is_small) {
		mm.resetColumns()
	} else {
		mm.setColumns()
	}
} 